import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@mui/system";
import { Button } from "@mui/material";

export const useHeaderStyles = makeStyles(() => ({
  primaryText: {
    fontWeight: "bold",
    fontSize: "1.3rem",
    color: "black",
    marginBottom: "10px",
    position: "relative",
    top: "15px",
    right: "5%",
  },
  headerBox: {
    // borderBottom: "1px solid",
    // borderBottomColor: "rgb(209 213 219)",
    position: "fixed",
    top: "0px",
    width: "100%",
    paddingLeft: "2%",
    paddingRight: "5%",
    paddingTop: "0.6rem",
    backgroundColor: "#ffffff",
    zIndex: 1000,
    // paddingBottom: "1.1rem",
  },
  logInButton: {
    width: "5.5rem",
    border: "2px solid",
    borderColor: "#2016ff",
    borderRadius: "5px",
    color: "#2016ff",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#171A53",
      color: "#fff",
    },
  },

  joinButton: {
    width: "10.5rem",
    // backgroundColor: "#4739ac",
    // backgroundColor: "#5553FF",
    color: "white",
    backgroundColor: "red",
    borderRadius: "5px",
    fontStyle: "bold",
    "&:hover": {
      // backgroundColor: "#171A53",
      color: "#fff",
    },
  },
}));

export const LogInButton = styled(Button)(({ theme }) => ({
  width: "5.5rem",
  height: "2.7rem",
  border: "1px solid",

  marginLeft: "33%",

  borderColor: "#000000",
  color: "#000000",
  fontWeight: 500,
  fontSize: "0.875rem",
  lineHeight: 1.75,
  letterSpacing: "0.02857em",
  textTransform: "uppercase",
  minWidth: "64px",
  padding: "6px 16px",
  border: 0,
  // borderRadius: "4px"
  // "&:hover": {
  //   backgroundColor: "#171A53",
  //   color: "#fff",
  // },
}));

export const JoinButton = styled(Button)(({ theme }) => ({
  width: "12.5rem",
  fontWeight: 500,

  color: "#fff",
  backgroundColor: "#4739ac",

  padding: ".75rem 2.5rem",
  textDecoration: "none",
  alignItems: "center",
  borderRadius: "999px",

  display: "inline-flex",
  fontSize: "0.775rem",
  justifyContent: "center",

  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "#171A53",
    color: "#fff",
  },
}));

export const SignUpButton = styled(Button)(({ theme }) => ({
  width: "12.5rem",
  fontWeight: 500,

  color: "#fff",
  backgroundColor: "#262626",

  padding: ".75rem 2.5rem",
  textDecoration: "none",
  alignItems: "center",
  borderRadius: "999px",

  display: "inline-flex",
  fontSize: "0.775rem",
  justifyContent: "center",

  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "#171A53",
    color: "#fff",
  },
}));
